"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_PIN_BUTTON = exports.SEND_ACCESS_CODE = exports.SAVE_REDIRECT_URL = exports.SAVE_QUERY = exports.RESEND_MESSAGE_COUNT = exports.RESEND_EMAIL_TIMEOUT = exports.REQUEST_STATUS = exports.REQUEST_FAILURE_YOU_ARE_A_ROBOT = exports.REQUEST_FAILURE_USER_IS_BLOCKED = exports.REQUEST_FAILURE_UNKNOWN_ERROR = exports.REQUEST_FAILURE_SUPPORT_NEEDED = exports.REQUEST_FAILURE_INVALID_PHONE_PIN = exports.REQUEST_FAILURE_INVALID_PHONE_NUMBER = exports.REGION_CODE_INPUT = exports.REFRESH_PROFILE = exports.REDIRECT_URL_LOCAL_STORAGE = exports.QUERY_LOCAL_STORAGE = exports.PRIVACY_POLICY_LINK = exports.PIN_USER_ACCOUNT_PROBLEM = exports.PIN_PHONE_VALIDATED = exports.PIN_PHONE_FORM_VIEWED = exports.PIN_PHONE_FORM_SUBMITTED = exports.PIN_PHONE_DIALOG_VIEWED = exports.PIN_EMAIL_RESEND = exports.PIN_EMAIL_FORM_VIEWED = exports.PIN_EMAIL_FORM_SUBMITTED = exports.PHONE_PIN_ERROR = exports.PHONE_PIN = exports.PHONE_NUMBER = exports.PHONE_INPUT = exports.PHONE = exports.MEXICAN_COUNTRY_CODE = exports.MASK_EMAIL_FORM_VIEWED = exports.MASK_EMAIL_FORM_SUBMITTED = exports.LOGOUT_WITHOUT_REDIRECT = exports.LOGOUT = exports.LOGIN_USER_CREATED = exports.LOGIN_SUCCESS = exports.LOGIN_SOCIAL_RESOLVER_PAGE_VIEWED = exports.LOGIN_SOCIAL_PHONE_MATCHED = exports.LOGIN_SOCIAL_CREDENTIAL_MATCHED = exports.LOGIN_SKIP_CLICKED = exports.LOGIN_PHONE_FORM_VIEWED = exports.LOGIN_PHONE_FORM_SUBMITTED = exports.LOGIN_PAGE_VIEWED = exports.LOGIN_OPTION_SELECTED = exports.LOGIN_OPTION_PAGE_VIEWED = exports.LOGIN_ON_SUBMIT_BUTTON = exports.LOGIN_FORM_RESUBMITTED = exports.LOGIN_FLOW = exports.LOGIN_FAILURE_INVALID_EMAIL_PIN = exports.LOGIN_FAILURE_INVALID_EMAIL_MASK = exports.LOGIN_EMAIL_VALIDATION_CODE_VIEWED = exports.LOGIN_EMAIL_VALIDATION_CODE_SUBMITTED = exports.LOGIN_EMAIL_MATCHING_CONFIRMED = exports.LOGIN_EMAIL_CODE_DELIVERY_PROBLEM = exports.LOGIN_EMAIL_ACCOUNT_PROBLEM = exports.LOGIN_EMAIL_ACCOUNT_MATCHING = exports.LOGIN_CREATE_USER_PAGE_VIEWED = exports.LOGIN_CREATE_USER_FORM_SUBMITTED = exports.LOGIN_ADDICIONAL_EMAIL_ADDED = exports.JWT_AUTH = exports.IS_PHONE_REGISTERED = exports.IMPLIED_SKIP_BUTTON_TEST_ID = exports.IMPLIED_GO_BACK_CLOSE_BUTTON_TEST_ID = exports.GOOGLE = exports.FLAG_WIDTH = exports.ERROR = exports.EMAIL_PIN_ERROR = exports.EMAIL_PIN = exports.EMAIL_MASK = exports.DIFFERENT_EMAIL_SUBMITTED = exports.DEFAULT_MAX_LENGTH = exports.DEFAULT_DDD_MAX_LENGTH = exports.COUTRY_CODE = exports.COUNTRY_SEARCH_INPUT = exports.COUNTRY_FLAGS_LINK = exports.COUNTRY_CODE_WIDTH_SM_DEFAULT = exports.COUNTRY_CODE_WIDTH_OFFSET = exports.COUNTRY_CODE_MAX_LENGTH = exports.COUNTRY_CODE_INPUT = exports.COUNTRY_CODE_DDD_MAX_LENGTH = exports.CONFIRM_PIN_BUTTON = exports.COGNITO = exports.CODE_NOT_RECEIVED = exports.CODE_INPUT_MIN_LENGTH = exports.CODE_INPUT_LENGTH = exports.CODE = exports.CLEAR_USER = exports.CLEAR_RESPONSE = exports.CLEAR_REQUEST_STATUS = exports.CHANNEL_WHATSAPP = exports.CHANNEL_SMS = exports.BRAZIL_INDEX = exports.BRAZILIAN_ISO = exports.BRAZILIAN_COUNTRY_CODE = exports.BEGIN_SOCIAL_LOGIN = exports.BEGIN_SOCIAL_EMAIL_CONFIRMATION = exports.BEGIN_ACCOUNT_OWNERSHIP = exports.APPLE = void 0;
exports.success = exports.loginPaths = exports.errors = exports.WHATSAPP_BUTTON = exports.VALIDATE_PIN_CODE = exports.VALIDATE_PHONE_OWNERSHIP = exports.VALIDATE_PHONE_ACCESS_CODE = exports.VALIDATE_EMAIL_PIN = exports.VALIDATE_EMAIL_OWNERSHIP = exports.VALIDATE_EMAIL_MASK = exports.UPDATE_USER_WITH_SOCIAL_USER_DATA = exports.UPDATE_USER_PHONE = exports.UPDATE_USER_CHANNEL = exports.UPDATE_USER_ATTRIBUTE = exports.UPDATE_USER = exports.TERMS_OF_SERVICE_LINK = exports.SUCCESS = exports.SUBMIT_ACCOUNT_FORM = exports.SOCIAL_VALIDATE_PHONE_ACCESS_CODE = exports.SOCIAL_VALIDATE_AND_CREATE_ACCOUNT = exports.SOCIAL_SUBMIT_ACCOUNT_FORM = exports.SOCIAL_RESOLVER_TIMEOUT_MS = exports.SOCIAL_RESOLVER_RETRY_MS = exports.SOCIAL_PROVIDERS = exports.SOCIAL_LOGIN_SUCCESS = exports.SOCIAL_LOGIN_SEND_ACCESS_CODE = exports.SOCIAL_LOGIN_FORM_RESUBMITTED = exports.SOCIAL_LOGIN_CREATE_USER_PAGE_VIEWED = exports.SOCIAL_LOGIN_CREATE_USER_FORM_SUBMITTED = exports.SMS_BUTTON = exports.SIGN_IN_WITH_PHONE_BUTTON = exports.SIGN_IN_WITH_GOOGLE_BUTTON = exports.SIGN_IN_WITH_APPLE_BUTTON = exports.SET_RESPONSE = exports.SET_FIRST_VISIT = void 0;
var SET_RESPONSE = "auth/container/SET_RESPONSE";
exports.SET_RESPONSE = SET_RESPONSE;
var CLEAR_RESPONSE = "auth/container/CLEAR_RESPONSE";
exports.CLEAR_RESPONSE = CLEAR_RESPONSE;
var CLEAR_REQUEST_STATUS = "auth/container/CLEAR_REQUEST_STATUS";
exports.CLEAR_REQUEST_STATUS = CLEAR_REQUEST_STATUS;
var LOGIN_PAGE_VIEWED = "auth/container/LOGIN_PAGE_VIEWED";
exports.LOGIN_PAGE_VIEWED = LOGIN_PAGE_VIEWED;
var LOGIN_PHONE_FORM_VIEWED = "auth/container/LOGIN_PHONE_FORM_VIEWED";
exports.LOGIN_PHONE_FORM_VIEWED = LOGIN_PHONE_FORM_VIEWED;
var LOGIN_PHONE_FORM_SUBMITTED = "auth/container/LOGIN_PHONE_FORM_SUBMITTED";
exports.LOGIN_PHONE_FORM_SUBMITTED = LOGIN_PHONE_FORM_SUBMITTED;
var LOGIN_SKIP_CLICKED = "auth/container/LOGIN_SKIP_CLICKED";
exports.LOGIN_SKIP_CLICKED = LOGIN_SKIP_CLICKED;
var LOGIN_CREATE_USER_PAGE_VIEWED = "auth/container/LOGIN_CREATE_USER_PAGE_VIEWED";
exports.LOGIN_CREATE_USER_PAGE_VIEWED = LOGIN_CREATE_USER_PAGE_VIEWED;
var SOCIAL_LOGIN_CREATE_USER_PAGE_VIEWED = "auth/container/SOCIAL_LOGIN_CREATE_USER_PAGE_VIEWED";
exports.SOCIAL_LOGIN_CREATE_USER_PAGE_VIEWED = SOCIAL_LOGIN_CREATE_USER_PAGE_VIEWED;
var PIN_PHONE_FORM_VIEWED = "auth/container/PIN_PHONE_FORM_VIEWED";
exports.PIN_PHONE_FORM_VIEWED = PIN_PHONE_FORM_VIEWED;
var PIN_PHONE_FORM_SUBMITTED = "auth/container/PIN_PHONE_FORM_SUBMITTED";
exports.PIN_PHONE_FORM_SUBMITTED = PIN_PHONE_FORM_SUBMITTED;
var PIN_PHONE_DIALOG_VIEWED = "auth/container/PIN_PHONE_DIALOG_VIEWED";
exports.PIN_PHONE_DIALOG_VIEWED = PIN_PHONE_DIALOG_VIEWED;
var PIN_PHONE_VALIDATED = "auth/container/PIN_PHONE_VALIDATED";
exports.PIN_PHONE_VALIDATED = PIN_PHONE_VALIDATED;
var MASK_EMAIL_FORM_VIEWED = "auth/container/MASK_EMAIL_FORM_VIEWED";
exports.MASK_EMAIL_FORM_VIEWED = MASK_EMAIL_FORM_VIEWED;
var MASK_EMAIL_FORM_SUBMITTED = "auth/container/MASK_EMAIL_FORM_SUBMITTED";
exports.MASK_EMAIL_FORM_SUBMITTED = MASK_EMAIL_FORM_SUBMITTED;
var DIFFERENT_EMAIL_SUBMITTED = "auth/container/DIFFERENT_EMAIL_SUBMITTED";
exports.DIFFERENT_EMAIL_SUBMITTED = DIFFERENT_EMAIL_SUBMITTED;
var PIN_EMAIL_FORM_VIEWED = "auth/container/PIN_EMAIL_FORM_VIEWED";
exports.PIN_EMAIL_FORM_VIEWED = PIN_EMAIL_FORM_VIEWED;
var PIN_EMAIL_FORM_SUBMITTED = "auth/container/PIN_EMAIL_FORM_SUBMITTED";
exports.PIN_EMAIL_FORM_SUBMITTED = PIN_EMAIL_FORM_SUBMITTED;
var PIN_EMAIL_RESEND = "auth/container/PIN_EMAIL_RESEND";
exports.PIN_EMAIL_RESEND = PIN_EMAIL_RESEND;
var LOGIN_CREATE_USER_FORM_SUBMITTED = "auth/container/LOGIN_CREATE_USER_FORM_SUBMITTED";
exports.LOGIN_CREATE_USER_FORM_SUBMITTED = LOGIN_CREATE_USER_FORM_SUBMITTED;
var SOCIAL_LOGIN_CREATE_USER_FORM_SUBMITTED = "auth/container/SOCIAL_LOGIN_CREATE_USER_FORM_SUBMITTED";
exports.SOCIAL_LOGIN_CREATE_USER_FORM_SUBMITTED = SOCIAL_LOGIN_CREATE_USER_FORM_SUBMITTED;
var LOGIN_SOCIAL_CREDENTIAL_MATCHED = "auth/container/LOGIN_SOCIAL_CREDENTIAL_MATCHED";
exports.LOGIN_SOCIAL_CREDENTIAL_MATCHED = LOGIN_SOCIAL_CREDENTIAL_MATCHED;
var LOGIN_SOCIAL_PHONE_MATCHED = "auth/container/LOGIN_SOCIAL_PHONE_MATCHED";
exports.LOGIN_SOCIAL_PHONE_MATCHED = LOGIN_SOCIAL_PHONE_MATCHED;
var LOGIN_SUCCESS = "auth/container/LOGIN_SUCCESS";
exports.LOGIN_SUCCESS = LOGIN_SUCCESS;
var LOGIN_USER_CREATED = "auth/container/LOGIN_USER_CREATED";
exports.LOGIN_USER_CREATED = LOGIN_USER_CREATED;
var LOGIN_ON_SUBMIT_BUTTON = "auth/container/LOGIN_ON_SUBMIT_BUTTON";
exports.LOGIN_ON_SUBMIT_BUTTON = LOGIN_ON_SUBMIT_BUTTON;
var LOGIN_FORM_RESUBMITTED = "auth/container/LOGIN_FORM_RESUBMITTED";
exports.LOGIN_FORM_RESUBMITTED = LOGIN_FORM_RESUBMITTED;
var SOCIAL_LOGIN_FORM_RESUBMITTED = "auth/container/SOCIAL_LOGIN_FORM_RESUBMITTED";
exports.SOCIAL_LOGIN_FORM_RESUBMITTED = SOCIAL_LOGIN_FORM_RESUBMITTED;
var LOGOUT = "LOGOUT";
exports.LOGOUT = LOGOUT;
var LOGOUT_WITHOUT_REDIRECT = "LOGOUT_WITHOUT_REDIRECT";
exports.LOGOUT_WITHOUT_REDIRECT = LOGOUT_WITHOUT_REDIRECT;
var REQUEST_FAILURE_INVALID_PHONE_NUMBER = "auth/container/REQUEST_FAILURE_INVALID_PHONE_NUMBER";
exports.REQUEST_FAILURE_INVALID_PHONE_NUMBER = REQUEST_FAILURE_INVALID_PHONE_NUMBER;
var REQUEST_FAILURE_INVALID_PHONE_PIN = "auth/container/REQUEST_FAILURE_INVALID_PHONE_PIN";
exports.REQUEST_FAILURE_INVALID_PHONE_PIN = REQUEST_FAILURE_INVALID_PHONE_PIN;
var REQUEST_FAILURE_UNKNOWN_ERROR = "auth/container/REQUEST_FAILURE_UNKNOWN_ERROR";
exports.REQUEST_FAILURE_UNKNOWN_ERROR = REQUEST_FAILURE_UNKNOWN_ERROR;
var REQUEST_FAILURE_YOU_ARE_A_ROBOT = "auth/container/REQUEST_FAILURE_YOU_ARE_A_ROBOT";
exports.REQUEST_FAILURE_YOU_ARE_A_ROBOT = REQUEST_FAILURE_YOU_ARE_A_ROBOT;
var REQUEST_FAILURE_USER_IS_BLOCKED = "auth/container/REQUEST_FAILURE_USER_IS_BLOCKED";
exports.REQUEST_FAILURE_USER_IS_BLOCKED = REQUEST_FAILURE_USER_IS_BLOCKED;
var LOGIN_FAILURE_INVALID_EMAIL_PIN = "auth/container/LOGIN_FAILURE_INVALID_EMAIL_PIN";
exports.LOGIN_FAILURE_INVALID_EMAIL_PIN = LOGIN_FAILURE_INVALID_EMAIL_PIN;
var LOGIN_FAILURE_INVALID_EMAIL_MASK = "auth/container/LOGIN_FAILURE_INVALID_EMAIL_MASK";
exports.LOGIN_FAILURE_INVALID_EMAIL_MASK = LOGIN_FAILURE_INVALID_EMAIL_MASK;
var REQUEST_FAILURE_SUPPORT_NEEDED = "auth/container/REQUEST_FAILURE_SUPPORT_NEEDED";
exports.REQUEST_FAILURE_SUPPORT_NEEDED = REQUEST_FAILURE_SUPPORT_NEEDED;
var REFRESH_PROFILE = "auth/container/REFRESH_PROFILE";
exports.REFRESH_PROFILE = REFRESH_PROFILE;
var SEND_ACCESS_CODE = "auth/container/SEND_ACCESS_CODE";
exports.SEND_ACCESS_CODE = SEND_ACCESS_CODE;
var SUBMIT_ACCOUNT_FORM = "auth/container/SUBMIT_ACCOUNT_FORM";
exports.SUBMIT_ACCOUNT_FORM = SUBMIT_ACCOUNT_FORM;
var SOCIAL_SUBMIT_ACCOUNT_FORM = "auth/container/SOCIAL_SUBMIT_ACCOUNT_FORM";
exports.SOCIAL_SUBMIT_ACCOUNT_FORM = SOCIAL_SUBMIT_ACCOUNT_FORM;
var BEGIN_SOCIAL_LOGIN = "auth/container/BEGIN_SOCIAL_LOGIN";
exports.BEGIN_SOCIAL_LOGIN = BEGIN_SOCIAL_LOGIN;
var BEGIN_ACCOUNT_OWNERSHIP = "auth/container/BEGIN_ACCOUNT_OWNERSHIP";
exports.BEGIN_ACCOUNT_OWNERSHIP = BEGIN_ACCOUNT_OWNERSHIP;
var BEGIN_SOCIAL_EMAIL_CONFIRMATION = "auth/container/BEGIN_SOCIAL_EMAIL_CONFIRMATION";
exports.BEGIN_SOCIAL_EMAIL_CONFIRMATION = BEGIN_SOCIAL_EMAIL_CONFIRMATION;
var VALIDATE_PHONE_OWNERSHIP = "auth/container/VALIDATE_PHONE_OWNERSHIP";
exports.VALIDATE_PHONE_OWNERSHIP = VALIDATE_PHONE_OWNERSHIP;
var VALIDATE_EMAIL_OWNERSHIP = "auth/container/VALIDATE_EMAIL_OWNERSHIP";
exports.VALIDATE_EMAIL_OWNERSHIP = VALIDATE_EMAIL_OWNERSHIP;
var UPDATE_USER = "auth/container/UPDATE_USER";
exports.UPDATE_USER = UPDATE_USER;
var UPDATE_USER_ATTRIBUTE = "auth/container/UPDATE_USER_ATTRIBUTE";
exports.UPDATE_USER_ATTRIBUTE = UPDATE_USER_ATTRIBUTE;
var UPDATE_USER_PHONE = "auth/container/UPDATE_USER_PHONE";
exports.UPDATE_USER_PHONE = UPDATE_USER_PHONE;
var UPDATE_USER_CHANNEL = "auth/containers/UPDATE_USER_CHANNEL";
exports.UPDATE_USER_CHANNEL = UPDATE_USER_CHANNEL;
var UPDATE_USER_WITH_SOCIAL_USER_DATA = "auth/container/UPDATE_USER_WITH_SOCIAL_USER_DATA";
exports.UPDATE_USER_WITH_SOCIAL_USER_DATA = UPDATE_USER_WITH_SOCIAL_USER_DATA;
var VALIDATE_EMAIL_MASK = "auth/container/VALIDATE_EMAIL_MASK";
exports.VALIDATE_EMAIL_MASK = VALIDATE_EMAIL_MASK;
var VALIDATE_EMAIL_PIN = "auth/container/VALIDATE_EMAIL_PIN";
exports.VALIDATE_EMAIL_PIN = VALIDATE_EMAIL_PIN;
var VALIDATE_PHONE_ACCESS_CODE = "auth/container/VALIDATE_PHONE_ACCESS_CODE";
exports.VALIDATE_PHONE_ACCESS_CODE = VALIDATE_PHONE_ACCESS_CODE;
var SOCIAL_VALIDATE_PHONE_ACCESS_CODE = "auth/container/SOCIAL_VALIDATE_PHONE_ACCESS_CODE";
exports.SOCIAL_VALIDATE_PHONE_ACCESS_CODE = SOCIAL_VALIDATE_PHONE_ACCESS_CODE;
var SOCIAL_VALIDATE_AND_CREATE_ACCOUNT = "auth/container/SOCIAL_VALIDATE_AND_CREATE_ACCOUNT";
exports.SOCIAL_VALIDATE_AND_CREATE_ACCOUNT = SOCIAL_VALIDATE_AND_CREATE_ACCOUNT;
var VALIDATE_PIN_CODE = "auth/container/VALIDATE_PIN_CODE";
exports.VALIDATE_PIN_CODE = VALIDATE_PIN_CODE;
var SAVE_REDIRECT_URL = "auth/container/SAVE_REDIRECT_URL";
exports.SAVE_REDIRECT_URL = SAVE_REDIRECT_URL;
var SAVE_QUERY = "auth/container/SAVE_QUERY";
exports.SAVE_QUERY = SAVE_QUERY;
var CLEAR_USER = "auth/containers/CLEAR_USER";
exports.CLEAR_USER = CLEAR_USER;
var SET_FIRST_VISIT = "auth/containers/SET_FIRST_VISIT";
exports.SET_FIRST_VISIT = SET_FIRST_VISIT;
var PIN_USER_ACCOUNT_PROBLEM = "auth/container/PIN_USER_ACCOUNT_PROBLEM";
exports.PIN_USER_ACCOUNT_PROBLEM = PIN_USER_ACCOUNT_PROBLEM;
var LOGIN_OPTION_PAGE_VIEWED = "auth/container/LOGIN_OPTION_PAGE_VIEWED";
exports.LOGIN_OPTION_PAGE_VIEWED = LOGIN_OPTION_PAGE_VIEWED;
var LOGIN_OPTION_SELECTED = "auth/container/LOGIN_OPTION_SELECTED";
exports.LOGIN_OPTION_SELECTED = LOGIN_OPTION_SELECTED;
var LOGIN_SOCIAL_RESOLVER_PAGE_VIEWED = "auth/container/LOGIN_SOCIAL_RESOLVER_PAGE_VIEWED";
exports.LOGIN_SOCIAL_RESOLVER_PAGE_VIEWED = LOGIN_SOCIAL_RESOLVER_PAGE_VIEWED;
var LOGIN_EMAIL_ACCOUNT_MATCHING = "auth/container/LOGIN_EMAIL_ACCOUNT_MATCHING";
exports.LOGIN_EMAIL_ACCOUNT_MATCHING = LOGIN_EMAIL_ACCOUNT_MATCHING;
var LOGIN_EMAIL_MATCHING_CONFIRMED = "auth/container/LOGIN_EMAIL_MATCHING_CONFIRMED";
exports.LOGIN_EMAIL_MATCHING_CONFIRMED = LOGIN_EMAIL_MATCHING_CONFIRMED;
var LOGIN_EMAIL_ACCOUNT_PROBLEM = "auth/container/LOGIN_EMAIL_ACCOUNT_PROBLEM";
exports.LOGIN_EMAIL_ACCOUNT_PROBLEM = LOGIN_EMAIL_ACCOUNT_PROBLEM;
var LOGIN_EMAIL_VALIDATION_CODE_VIEWED = "auth/container/LOGIN_EMAIL_VALIDATION_CODE_VIEWED";
exports.LOGIN_EMAIL_VALIDATION_CODE_VIEWED = LOGIN_EMAIL_VALIDATION_CODE_VIEWED;
var LOGIN_EMAIL_VALIDATION_CODE_SUBMITTED = "auth/container/LOGIN_EMAIL_VALIDATION_CODE_SUBMITTED";
exports.LOGIN_EMAIL_VALIDATION_CODE_SUBMITTED = LOGIN_EMAIL_VALIDATION_CODE_SUBMITTED;
var LOGIN_EMAIL_CODE_DELIVERY_PROBLEM = "auth/container/LOGIN_EMAIL_CODE_DELIVERY_PROBLEM";
exports.LOGIN_EMAIL_CODE_DELIVERY_PROBLEM = LOGIN_EMAIL_CODE_DELIVERY_PROBLEM;
var LOGIN_ADDICIONAL_EMAIL_ADDED = "auth/container/LOGIN_ADDICIONAL_EMAIL_ADDED";
exports.LOGIN_ADDICIONAL_EMAIL_ADDED = LOGIN_ADDICIONAL_EMAIL_ADDED;
var SOCIAL_LOGIN_SUCCESS = "auth/container/SOCIAL_LOGIN_SUCCESS";
exports.SOCIAL_LOGIN_SUCCESS = SOCIAL_LOGIN_SUCCESS;
var SOCIAL_LOGIN_SEND_ACCESS_CODE = "auth/container/SOCIAL_LOGIN_SEND_ACCESS_CODE";
exports.SOCIAL_LOGIN_SEND_ACCESS_CODE = SOCIAL_LOGIN_SEND_ACCESS_CODE;
var ERROR = "ERROR";
exports.ERROR = ERROR;
var SUCCESS = "SUCCESS";
exports.SUCCESS = SUCCESS;
var CHANNEL_SMS = "SMS";
exports.CHANNEL_SMS = CHANNEL_SMS;
var CHANNEL_WHATSAPP = "WHATSAPP";
exports.CHANNEL_WHATSAPP = CHANNEL_WHATSAPP;
var BRAZILIAN_ISO = "BR";
exports.BRAZILIAN_ISO = BRAZILIAN_ISO;
var BRAZILIAN_COUNTRY_CODE = "55";
exports.BRAZILIAN_COUNTRY_CODE = BRAZILIAN_COUNTRY_CODE;
var MEXICAN_COUNTRY_CODE = "52";
exports.MEXICAN_COUNTRY_CODE = MEXICAN_COUNTRY_CODE;
var COUNTRY_CODE_MAX_LENGTH = 3;
exports.COUNTRY_CODE_MAX_LENGTH = COUNTRY_CODE_MAX_LENGTH;
var DEFAULT_DDD_MAX_LENGTH = 2;
exports.DEFAULT_DDD_MAX_LENGTH = DEFAULT_DDD_MAX_LENGTH;
var COUNTRY_CODE_DDD_MAX_LENGTH = 5;
exports.COUNTRY_CODE_DDD_MAX_LENGTH = COUNTRY_CODE_DDD_MAX_LENGTH;
var DEFAULT_MAX_LENGTH = 9;
exports.DEFAULT_MAX_LENGTH = DEFAULT_MAX_LENGTH;
var JWT_AUTH = "5AJWT_AUTH";
exports.JWT_AUTH = JWT_AUTH;
var RESEND_EMAIL_TIMEOUT = 10000;
exports.RESEND_EMAIL_TIMEOUT = RESEND_EMAIL_TIMEOUT;
var PHONE_PIN = "phone-pin";
exports.PHONE_PIN = PHONE_PIN;
var EMAIL_PIN = "email-pin";
exports.EMAIL_PIN = EMAIL_PIN;
var PHONE_PIN_ERROR = "phonePin";
exports.PHONE_PIN_ERROR = PHONE_PIN_ERROR;
var EMAIL_PIN_ERROR = "emailPin";
exports.EMAIL_PIN_ERROR = EMAIL_PIN_ERROR;
var EMAIL_MASK = "emailMask";
exports.EMAIL_MASK = EMAIL_MASK;
var IS_PHONE_REGISTERED = "isPhoneRegistered";
exports.IS_PHONE_REGISTERED = IS_PHONE_REGISTERED;
var CODE_INPUT_LENGTH = 6;
exports.CODE_INPUT_LENGTH = CODE_INPUT_LENGTH;
var CODE_INPUT_MIN_LENGTH = 5;
exports.CODE_INPUT_MIN_LENGTH = CODE_INPUT_MIN_LENGTH;
var FLAG_WIDTH = 20;
exports.FLAG_WIDTH = FLAG_WIDTH;
var BRAZIL_INDEX = 27;
exports.BRAZIL_INDEX = BRAZIL_INDEX;
var COUNTRY_CODE_WIDTH_OFFSET = 10;
exports.COUNTRY_CODE_WIDTH_OFFSET = COUNTRY_CODE_WIDTH_OFFSET;
var COUNTRY_CODE_WIDTH_SM_DEFAULT = 13;
exports.COUNTRY_CODE_WIDTH_SM_DEFAULT = COUNTRY_CODE_WIDTH_SM_DEFAULT;
var IMPLIED_GO_BACK_CLOSE_BUTTON_TEST_ID = "implied-go-back-close-button";
exports.IMPLIED_GO_BACK_CLOSE_BUTTON_TEST_ID = IMPLIED_GO_BACK_CLOSE_BUTTON_TEST_ID;
var IMPLIED_SKIP_BUTTON_TEST_ID = "implied-skip-button";
exports.IMPLIED_SKIP_BUTTON_TEST_ID = IMPLIED_SKIP_BUTTON_TEST_ID;
var COUTRY_CODE = "countryCode";
exports.COUTRY_CODE = COUTRY_CODE;
var PHONE_NUMBER = "phoneNumber";
exports.PHONE_NUMBER = PHONE_NUMBER;
var CODE = "code";
exports.CODE = CODE;
var GOOGLE = "Google";
exports.GOOGLE = GOOGLE;
var APPLE = "Apple";
exports.APPLE = APPLE;
var PHONE = "PHONE";
exports.PHONE = PHONE;
var RESEND_MESSAGE_COUNT = 20;
exports.RESEND_MESSAGE_COUNT = RESEND_MESSAGE_COUNT;
var SOCIAL_RESOLVER_RETRY_MS = 1000;
exports.SOCIAL_RESOLVER_RETRY_MS = SOCIAL_RESOLVER_RETRY_MS;
var SOCIAL_RESOLVER_TIMEOUT_MS = 10000;
exports.SOCIAL_RESOLVER_TIMEOUT_MS = SOCIAL_RESOLVER_TIMEOUT_MS;
var SMS_BUTTON = "sendSMS-button";
exports.SMS_BUTTON = SMS_BUTTON;
var WHATSAPP_BUTTON = "sendWhatApp-button";
exports.WHATSAPP_BUTTON = WHATSAPP_BUTTON;
var COUNTRY_CODE_INPUT = "country-code-input";
exports.COUNTRY_CODE_INPUT = COUNTRY_CODE_INPUT;
var REGION_CODE_INPUT = "region-code-input";
exports.REGION_CODE_INPUT = REGION_CODE_INPUT;
var PHONE_INPUT = "phone-input";
exports.PHONE_INPUT = PHONE_INPUT;
var COUNTRY_SEARCH_INPUT = "country-search-input";
exports.COUNTRY_SEARCH_INPUT = COUNTRY_SEARCH_INPUT;
var CODE_NOT_RECEIVED = "code-not-received";
exports.CODE_NOT_RECEIVED = CODE_NOT_RECEIVED;
var CONFIRM_PIN_BUTTON = "confirm-p\xEDn-button";
exports.CONFIRM_PIN_BUTTON = CONFIRM_PIN_BUTTON;
var SIGN_IN_WITH_GOOGLE_BUTTON = "sign-in-with-google-button";
exports.SIGN_IN_WITH_GOOGLE_BUTTON = SIGN_IN_WITH_GOOGLE_BUTTON;
var SIGN_IN_WITH_APPLE_BUTTON = "sign-in-with-apple-button";
exports.SIGN_IN_WITH_APPLE_BUTTON = SIGN_IN_WITH_APPLE_BUTTON;
var SIGN_IN_WITH_PHONE_BUTTON = "sign-in-with-phone-button";
exports.SIGN_IN_WITH_PHONE_BUTTON = SIGN_IN_WITH_PHONE_BUTTON;
var SEND_PIN_BUTTON = "send-pin-button";
exports.SEND_PIN_BUTTON = SEND_PIN_BUTTON;
var rootPath = "/auth/login";
var loginPaths = {
  root: rootPath,
  accessCode: "".concat(rootPath, "/access-code"),
  activateAccount: "".concat(rootPath, "/confirm-account"),
  createAccount: "".concat(rootPath, "/create-account"),
  verifyEmail: "".concat(rootPath, "/verify-email"),
  phoneNumberLogin: "".concat(rootPath, "/phone"),
  socialPhoneConfirmation: "".concat(rootPath, "/social/phone-confirmation"),
  socialOwnershipVerification: "".concat(rootPath, "/social/account-ownership"),
  socialCreateAccout: "".concat(rootPath, "/social/create-account"),
  socialAccessCode: "".concat(rootPath, "/social/access-code"),
  socialLogin: "".concat(rootPath, "/social/options"),
  socialAccountMatch: "".concat(rootPath, "/social/account-match"),
  socialEmailConfirmation: "".concat(rootPath, "/social/email-confirmation"),
  socialCredentialAssociated: "".concat(rootPath, "/social/credential-associated")
};
exports.loginPaths = loginPaths;
var errors = {
  invalidChannel: "InvalidChannel",
  invalidPhone: "InvalidPhone",
  invalidSession: "InvalidSession",
  invalidToken: "InvalidToken",
  invalidEmailMask: "InvalidEmailMask",
  userNotFound: "UserNotFound",
  youAreARobot: "YouAreARobot",
  emailAlreadyPresent: "EmailAlreadyPresent",
  unknownError: "UnknownError",
  socialCredentialMatched: "SocialCredentialMatched",
  socialCredentialUnknown: "SocialCredentialUnknown",
  phoneNumberMatched: "PhoneNumberMatched",
  cognitoNotAuthorized: "CognitoNotAuthorized",
  unauthorized: "Unauthorized",
  userIsBlocked: "UserIsBlocked",
  supportNeeded: "SupportNeeded"
};
exports.errors = errors;
var success = {
  resendAccessCode: "ResendAccessCode",
  resendEmail: "ResendEmail"
};
exports.success = success;
var TERMS_OF_SERVICE_LINK = "https://www.quintoandar.com.br/termos-e-politica-de-privacidade/#termos";
exports.TERMS_OF_SERVICE_LINK = TERMS_OF_SERVICE_LINK;
var PRIVACY_POLICY_LINK = "https://www.quintoandar.com.br/termos-e-politica-de-privacidade/#privacidade";
exports.PRIVACY_POLICY_LINK = PRIVACY_POLICY_LINK;
var COUNTRY_FLAGS_LINK = "https://thumbor.quintoandar.com.br/country-flags.png";
exports.COUNTRY_FLAGS_LINK = COUNTRY_FLAGS_LINK;
var REDIRECT_URL_LOCAL_STORAGE = "bioma-auth-redirect-url";
exports.REDIRECT_URL_LOCAL_STORAGE = REDIRECT_URL_LOCAL_STORAGE;
var QUERY_LOCAL_STORAGE = "bioma-auth-query";
exports.QUERY_LOCAL_STORAGE = QUERY_LOCAL_STORAGE;
var COGNITO = "COGNITO";
exports.COGNITO = COGNITO;
var SOCIAL_PROVIDERS = Object.freeze({
  "SIGNINWITHAPPLE": "APPLE",
  "GOOGLE": "GOOGLE"
});
exports.SOCIAL_PROVIDERS = SOCIAL_PROVIDERS;
var REQUEST_STATUS = Object.freeze({
  UNSET: "UNSET",
  LOADING: "LOADING",
  FAILURE: "FAILURE",
  SUCCESS: "SUCCESS"
});
exports.REQUEST_STATUS = REQUEST_STATUS;
var LOGIN_FLOW = Object.freeze({
  PHONE_SIGN_IN: "PHONE_SIGN_IN",
  PHONE_SIGN_UP: "PHONE_SIGN_UP",
  PHONE_WITH_MASKED_EMAIL_VALIDATION: "PHONE_WITH_MASKED_EMAIL_VALIDATION",
  PHONE_WITH_EMAIL_PIN_VALIDATION: "PHONE_WITH_EMAIL_PIN_VALIDATION",
  SOCIAL_DIRECT_SIGN_IN: "SOCIAL_DIRECT_SIGN_IN",
  SOCIAL_EMAIL_MATCH_ASSOCIATION: "SOCIAL_EMAIL_MATCH_ASSOCIATION",
  SOCIAL_PHONE_MATCH_ASSOCIATION: "SOCIAL_PHONE_MATCH_ASSOCIATION",
  SOCIAL_SIGN_UP: "SOCIAL_SIGN_UP",
  SOCIAL_SIGN_UP_WITHOUT_CPF: "SOCIAL_SIGN_UP_WITHOUT_CPF"
});
exports.LOGIN_FLOW = LOGIN_FLOW;